"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHistorySource = void 0;
const react_1 = require("react");
const history_context_1 = require("../../providers/history/history-context");
const list_source_hook_1 = require("../../utils/list-source-hook");
function useHistorySource(id) {
    const { url } = (0, react_1.useContext)(history_context_1.HistoryContext);
    return (0, list_source_hook_1.useListSource)({
        url: `${url}/${id}/full`,
    });
}
exports.useHistorySource = useHistorySource;
//# sourceMappingURL=history-api.js.map